<script setup>
import CFContentPlaceholders from '@/shared/components/CFContentPlaceholders.vue';
import CFContentPlaceholdersHeading from '@/shared/components/CFContentPlaceholdersHeading.vue';

defineProps({
    count: {
        type: Number,
        default: 3,
    },
});
</script>

<template>
    <CFContentPlaceholders class="space-y-6">
        <hr class="bg-primary/15 h-px border-0" />
        <template
            v-for="i in count"
            :key="i"
        >
            <CFContentPlaceholdersHeading />
            <hr class="bg-primary/15 h-px border-0" />
        </template>
    </CFContentPlaceholders>
</template>
